module.exports = __webpack_public_path__ + "img/art-59.c7e046ad.png";